import axios from "axios";
import { useEffect, useState } from "react";
import type { Publication } from "./publications.types";

const PUBLICATIONS_ENDPOINT = `${process.env.REACT_APP_SERVER_IP}/api/publications`;

type UsePublicationsResult = {
  publications: Array<Publication>;
  isLoading: boolean;
  error: string | null;
};

/** Load the publication list from the server (replaces the old static array). */
export const usePublications = (): UsePublicationsResult => {
  const [publications, setPublications] = useState<Array<Publication>>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isActive = true;

    async function loadPublications(): Promise<void> {
      try {
        const response = await axios.get<Array<Publication>>(
          PUBLICATIONS_ENDPOINT,
        );
        if (isActive) {
          setPublications(response.data);
          setError(null);
        }
      } catch {
        if (isActive) {
          setError("Could not load publications");
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    }

    void loadPublications();

    return () => {
      isActive = false;
    };
  }, []);

  return { publications, isLoading, error };
};
